export default __webpack_public_path__ + "static/media/workspace_icon_gray.a1a2e134.svg";